import {
  getAuth,
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  onAuthStateChanged,
  User,
} from 'firebase/auth';
import { create } from 'zustand';
import { app } from './config';

interface AuthStore {
  user: User | null;
  loading: boolean;
  error: string | null;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
}

export const useAuthStore = create<AuthStore>((set) => ({
  user: null,
  loading: true,
  error: null,
  signIn: async (email: string, password: string) => {
    try {
      set({ loading: true, error: null });
      const auth = getAuth(app);
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error) {
      set({ error: 'Credenciales inválidas' });
      throw error;
    } finally {
      set({ loading: false });
    }
  },
  signOut: async () => {
    try {
      set({ loading: true, error: null });
      const auth = getAuth(app);
      await firebaseSignOut(auth);
    } catch (error) {
      set({ error: 'Error al cerrar sesión' });
      throw error;
    } finally {
      set({ loading: false });
    }
  },
}));

// Initialize auth state listener
const auth = getAuth(app);
onAuthStateChanged(auth, (user) => {
  useAuthStore.setState({ user, loading: false });
});
